import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
const buyers = [{
  name: 'Sarah M.',
  location: 'Austin, TX',
  flag: '🇺🇸',
  minutes: 4
}, {
  name: 'Mark D.',
  location: 'San Diego, CA',
  flag: '🇺🇸',
  minutes: 12
}, {
  name: 'Jessica L.',
  location: 'Melbourne, AUS',
  flag: '🇦🇺',
  minutes: 23
}, {
  name: 'Ryan P.',
  location: 'Portland, OR',
  flag: '🇺🇸',
  minutes: 7
}, {
  name: 'Emily R.',
  location: 'Toronto, CAN',
  flag: '🇨🇦',
  minutes: 18
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 800);
    }, 9000);
    return () => clearInterval(cycle);
  }, [visible]);
  const buyer = buyers[idx];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-203">
      <div className="bg-white rounded-lg shadow-2xl border border-pilates-slate/20 p-3 pr-4 flex items-center gap-3 max-w-[300px]" data-id="element-204">
        <div className="bg-pilates-blue-dark w-9 h-9 rounded-sm flex items-center justify-center flex-shrink-0 border border-pilates-lavender/30" data-id="element-205">
          <Check className="w-5 h-5 text-pilates-lavender" strokeWidth={3} data-id="element-206" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-207">
          <p className="text-sm font-bold text-pilates-blue-dark leading-tight truncate" data-id="element-208">
            {buyer.name}, from {buyer.location} {buyer.flag}
          </p>
          <p className="text-xs text-pilates-slate leading-tight mt-0.5" data-id="element-209">
            Just purchased • {buyer.minutes} min ago •{' '}
            <span className="text-pilates-sage-dark font-semibold" data-id="element-210">
              Verified Purchase
            </span>
          </p>
        </div>
        <button onClick={() => setVisible(false)} className="text-pilates-slate hover:text-pilates-blue-dark flex-shrink-0" aria-label="Close" data-id="element-211">
          <X className="w-4 h-4" data-id="element-212" />
        </button>
      </div>
    </div>;
}